import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { environment } from '../../../environments/environment';
import { Conversation } from '../type/conversation.type';
import { Message } from '../type/message.type';
@Injectable({
    providedIn: 'root',
})
export class ChatService {
    private chatApiUrl = `${environment.microservices.realTime.baseUrl}/${environment.microservices.realTime.chat.baseUrl}`;
    private getConversationApiUrl = `${this.chatApiUrl}/${environment.microservices.realTime.chat.getConversation}`;

    constructor(private http: HttpClient) {}

    getMyConversations(): Observable<Conversation[]> {
        return this.http.get<Conversation[]>(`${this.getConversationApiUrl}`);
    }
    getConversationMessages(conversationId: string): Observable<Message[]> {
        return this.http.get<Message[]>(`${this.getConversationApiUrl}/${conversationId}/messages`);
    }

    markConversationAsRead(conversationId: string): Observable<void> {
        return this.http.post<void>(`${this.getConversationApiUrl}/${conversationId}/read`, {});
    }
}
